import React, {useState} from 'react';
import QRCodeSVG, {QRCodeCanvas} from "qrcode.react";

function Th_title({title, colspan, required, children, className, thumb, sub, auth}) {
    const childArray = Array.isArray(children) ? children : [children];
    const [clicked, setClicked] = useState(false);
    const tdClassName = `${className ?? ""} simms-detail-td ${thumb ? "simms-detail-td-thumb" : ""}`.trim();

    return (
        <>
            <th className={`${thumb ? 'fieldset-th-thumb simms-detail-th-thumb': 'fieldset-th simms-detail-th'} truncate`}>
                <span className={"input-label detail-input-label text-breaker max-w-[10rem]"}>{title}</span>
                {required &&
                    <span className="c-red ml-1">* </span>
                }
            </th>

            <td
                {...(colspan > 1 ? {colSpan: colspan} : {})}
                className={tdClassName}
                onClick={auth ? () => setClicked(true) : undefined}
            >
                {childArray.map((child, index) => {
                    if (
                        React.isValidElement(child) &&
                        typeof child.type !== 'string' &&
                        child.type !== QRCodeSVG &&
                        child.type !== QRCodeCanvas
                    ) {
                        const resolvedAuth = child.props.auth !== undefined ? child.props.auth : auth;
                        return React.cloneElement(child, { key: index, auth: resolvedAuth, constraint:{required:required},
                            required: required, title: child.props.title?? title,
                            clicked: clicked, setClicked: setClicked,
                            sub:sub, type : child.props.constraint?.type ?? undefined
                        });
                    }
                    return child;
                })}
            </td>
        </>
    );
}

export default Th_title;